import React, { FC } from 'react'

import { ProjectDetailItem } from 'src/components/molecules'

import { ProjectDetailEntity } from 'src/types'

type Props = {
  project: ProjectDetailEntity
  className?: string
}

export const ProjectBuildingDetail: FC<Props> = ({ project, className }) => {
  return (
    <div className={className}>
      <div className="tw-grid tw-gap-r2">
        <ProjectDetailItem title="総戸数" detailText={project.roomCount ?? null} />
      </div>
    </div>
  )
}
